/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Pet_CategoryInputs */

const en_field_pet_category = /** @type {(inputs: Field_Pet_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pet Category`)
};

const es_field_pet_category = /** @type {(inputs: Field_Pet_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoría de mascota`)
};

const fr_field_pet_category = /** @type {(inputs: Field_Pet_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catégorie d'animal`)
};

const de_field_pet_category = /** @type {(inputs: Field_Pet_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tierkategorie`)
};

const ja_field_pet_category = /** @type {(inputs: Field_Pet_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ペットのカテゴリ`)
};

const zh_field_pet_category = /** @type {(inputs: Field_Pet_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`宠物类别`)
};

const ar_field_pet_category = /** @type {(inputs: Field_Pet_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فئة الحيوان الأليف`)
};

const id_field_pet_category = /** @type {(inputs: Field_Pet_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategori Hewan Peliharaan`)
};

const it_field_pet_category = /** @type {(inputs: Field_Pet_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria Animale`)
};

const ru_field_pet_category = /** @type {(inputs: Field_Pet_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Категория животного`)
};

const pt_field_pet_category = /** @type {(inputs: Field_Pet_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria do Pet`)
};

const ko_field_pet_category = /** @type {(inputs: Field_Pet_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`반려동물 분류`)
};

/**
* | output |
* | --- |
* | "Pet Category" |
*
* @param {Field_Pet_CategoryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_pet_category = /** @type {((inputs?: Field_Pet_CategoryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Pet_CategoryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_pet_category(inputs)
	if (locale === "es") return es_field_pet_category(inputs)
	if (locale === "fr") return fr_field_pet_category(inputs)
	if (locale === "de") return de_field_pet_category(inputs)
	if (locale === "ja") return ja_field_pet_category(inputs)
	if (locale === "zh") return zh_field_pet_category(inputs)
	if (locale === "ar") return ar_field_pet_category(inputs)
	if (locale === "id") return id_field_pet_category(inputs)
	if (locale === "it") return it_field_pet_category(inputs)
	if (locale === "ru") return ru_field_pet_category(inputs)
	if (locale === "pt") return pt_field_pet_category(inputs)
	return ko_field_pet_category(inputs)
});